import logo from "./logo.svg";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import React from "react";
import { BrowserRouter } from "react-router-dom";
import { AuthContextProvider } from "./context/authContext";
// import RenderRouters from "./routers/renderRoutes";
import RenderRouters from "./routers/renderRoutes";
import { store } from "./store";
import { Provider } from "react-redux";
import { TemplateProvider } from "./context/templateContext";
import { unregister } from './serviceWorker';

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <BrowserRouter>
      <AuthContextProvider>
        <TemplateProvider>
          <RenderRouters />
        </TemplateProvider>
      </AuthContextProvider>
    </BrowserRouter>
  </Provider>
  // </React.StrictMode>
);

unregister();
reportWebVitals();
